export { default as List } from 'notifications_config/containers/NotificationsConfigListContainer';
export { default as Form } from 'notifications_config/containers/NotificationsConfigFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/containers/index.js